import FormSelect from 'components/Select/FormSelect';
import React, { useEffect } from 'react';
import { IGetCategoriesShortResponse, IGetCategoriesShort, ITotalPrice } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCategoriesShortInfo } from 'backend/categories';

interface IDishModificationCategorySelect {
	setDishModificationCategory: (value: Nullable<string>) => void;
	totalPrices: ITotalPrice[];
}

const DishModificationCategorySelect: React.FC<IDishModificationCategorySelect> = ({
	totalPrices,
	setDishModificationCategory,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<
		IGetCategoriesShortResponse,
		IGetCategoriesShort
	>(totalPrices.length ? getCategoriesShortInfo : null, { restaurantIds: totalPrices.map((el) => el.restaurantId) });

	useEffect(() => {
		refetch();
	}, [totalPrices]);

	return (
		<FormSelect
			name="selectedDishModificationCategory"
			label="categoryLabel"
			options={response?.data.categories}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			disabled={!totalPrices.length || loading}
			onChange={setDishModificationCategory}
		/>
	);
};

export default React.memo(DishModificationCategorySelect);
